import React, { Component } from 'react';
import store from 'store2';
import { AUTH_TOKEN_KEY, AUTH_QUERY_PARAM } from './constants';
import AuthContext from './AuthContext';

const searchToQueryParamsDictionary = () =>
  location.search
    .replace('?', '')
    .split('&')
    .map(x => x.split('='))
    .reduce((hash, x) => {
      hash[x[0]] = x[1];
      return hash;
    }, {});

const cacheTokenFromUrlToLocalStorageAndClearUrl = () => {
  const queryParams = searchToQueryParamsDictionary();
  const token = queryParams[AUTH_QUERY_PARAM];

  if (!token) return;

  store.set(AUTH_TOKEN_KEY, token);

  const hasMultipleQueryParams = Object.keys(queryParams).length > 1;
  const toReplace = `${
    hasMultipleQueryParams ? '' : '?'
  }${AUTH_QUERY_PARAM}=${token}`;
  const urlWithoutAuth = location.href.replace(toReplace, '');
  history.replaceState({ path: urlWithoutAuth }, null, urlWithoutAuth);
};

class Authorize extends Component {
  constructor(props) {
    super(props);
    cacheTokenFromUrlToLocalStorageAndClearUrl();
    this.onAuthorizationError = this.onAuthorizationError.bind(this);
    this.state = {
      enabled: props.enabled,
      authRedirectUrl: props.authRedirectUrl,
      token: store.get(AUTH_TOKEN_KEY),
      onAuthorizationError: this.onAuthorizationError
    };
  }

  redirect() {
    window.location.replace(this.state.authRedirectUrl);
  }

  onAuthorizationError() {
    store.remove(AUTH_TOKEN_KEY);
    this.setState({
      token: null
    });
    this.redirect();
  }

  componentDidMount() {
    const { token, enabled } = this.state;
    if (enabled && !token) {
      this.redirect();
    }
  }

  render() {
    const { children } = this.props;
    const { token, enabled } = this.state;

    if (enabled && !token) {
      return null;
    }

    return (
      <AuthContext.Provider value={this.state}>{children}</AuthContext.Provider>
    );
  }
}

export default Authorize;
